// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyProject_container__2OGIb","text":"EmptyProject_text__1W2fy c-silver"};